
import Selector from "./Selector"
import { useEffect, useState } from "react";



function FetchParametersOfMovement({passData, resetDemographicsValue}) {

    const [Data, setData] = useState([])
    

    useEffect(() => {
        var url = '/api/parametersofmovement';
        fetch(url).then((res) =>
            res.json().then((res) => {
                setData(res.data.Characteristics)

          })
        )
        .catch((error) => {
          console.log("Refetching data!")
        });
      }, []);
      
      const valuesToRemove = ["Προσδιορισμός κατά σειρά προτίμησης μέσω διαβαθμισμένης κλίμακας 1-5", "Προσδιορισμός επιπέδου ικανοποίησης συγκεκριμένων παρεχόμενων υπηρεσιών και ανέσεων μέσω διαβαθμισμένης κλίμακας 1-5","Αιτιολόγηση μη χρήσης του μέσου μετακίνησης της προηγούμενης ερώτησης (ερώτηση 16)."];

      const filteredList = Data.filter(item => !valuesToRemove.includes(item));

      let SelectorData =  filteredList.map(x => ({value: x, label: x}));

      console.log("DATA", Data)
      
   

      const parametersOfMovementSelections = {
        title: "",
        defaultText: "Παράμετροι  κινητικότητας",
        options: SelectorData
    }

    
    
    return (
        <Selector props = {parametersOfMovementSelections} onSelect = {passData} resetDropdownValue = {resetDemographicsValue}></Selector>
      );

    };

export default FetchParametersOfMovement;

